export enum ValidationTabsEnum {
  INSITU_TAB = 'insitu',
  SATELLITE_TAB = 'satellite',
}
